import { generateId } from '../utils'

type Props = {
  description: string
  type: 'addedField' | 'addField'
  value: string
  order?: string
  questionId?: number
  rowOrder?: number
  formIndex?: string
}
export const generateSpanField = ({
  description,
  type,
  value,
  order = '',
  questionId,
  rowOrder,
  formIndex,
}: Props) => `<span
          contentEditable="false"
          data-description="${description}"
          data-order="${order}"
          data-id="${generateId()}"
          data-type="${type}"
          data-value="${value}"
          ${questionId ? `data-question-id="${questionId}"` : ''}
          ${rowOrder ? `data-row-order="${rowOrder}"` : ''}
          ${formIndex ? `data-form-index="${formIndex}"` : ''}
        >
        ${description}
        </span>`
